module.exports = __webpack_public_path__ + "img/user-menu.864f161e.svg";